const childIndentTimelineValues = [
  {
    id: 1,
    value: 'ROAD',
    label: 'ROAD LEG',
  },
  {
    id: 2,
    value: 'OCEAN',
    label: 'OCEAN LEG',
  },
  {
    id: 3,
    value: 'AIR',
    label: 'AIR LEG',
  },
];

const containerAirFormFields = {
  export: {
    4: [
      {
        label: 'Booking number',
        input_type: 'text',
        id: 'booking_number',
        isRequired: false,
        placeholder: 'Enter the number',
      },
      {
        label: 'Booking date',
        input_type: 'date',
        id: 'booking_date',
        isRequired: false,
        isBackDateRequired: true,
        placeholder: 'Enter date here',
      },
    ],
    5: [
      {
        label: 'AWB / Label no',
        input_type: 'text',
        id: 'label_number',
        isRequired: true,
        placeholder: 'Enter the number',
      },
      {
        label: 'AWB / Label date',
        input_type: 'date',
        id: 'booking_date',
        isRequired: true,
        isBackDateRequired: true,
        placeholder: 'Enter date here',
      },
    ] },
  import: {
    4: [
      {
        label: 'Booking number',
        input_type: 'text',
        id: 'booking_number',
        isRequired: false,
        placeholder: 'Enter the number',
      },
      {
        label: 'Delivery date for PoL',
        input_type: 'date',
        id: 'delivery_date_for_pol',
        isRequired: false,
        isBackDateRequired: true,
        placeholder: 'Enter date here',
      },
      {
        label: 'Expected Shipment departure date',
        input_type: 'date',
        id: 'expected_shipment_departure_date',
        isRequired: false,
        isBackDateRequired: true,
        placeholder: 'Enter date here',
      },
    ],
    5: [
      {
        label: 'Label number',
        input_type: 'text',
        id: 'label_number',
        isRequired: true,
        placeholder: 'Enter the number',
      },
      {
        label: 'Control Number',
        input_type: 'text',
        id: 'control_number',
        isRequired: true,
        placeholder: 'Enter the number',
      },
    ] },
};


const containerFormFields = {
  export: [
    {
      label: 'Booking number',
      input_type: 'text',
      id: 'booking_number',
      isRequired: true,
      placeholder: 'Enter the number',
    },
    {
      label: 'Delivery Date for POL',
      input_type: 'date',
      id: 'delivery_date_for_pol',
      isRequired: true,
      isBackDateRequired: true,
      placeholder: 'Enter date here',
    },
    {
      label: 'Vessel Sailing Date',
      input_type: 'date',
      id: 'vessel_sailing_date',
      isRequired: true,
      isBackDateRequired: true,
      placeholder: 'Enter date here',
    },
    {
      label: 'Empty Container Pickup Port',
      input_type: 'dropdown',
      id: 'port_for_container_pickup',
      isRequired: true,
      placeholder: 'Select Port',
    },
  ],
  import: [
    {
      label: 'Booking number',
      input_type: 'text',
      id: 'booking_number',
      isRequired: true,
      placeholder: 'Enter the number',
    },
    {
      label: 'POL Cut off Date',
      input_type: 'date',
      id: 'delivery_date_for_pol',
      isRequired: true,
      isBackDateRequired: true,
      placeholder: 'Enter date here',
    },
    {
      label: 'Vessel Sailing Date',
      input_type: 'date',
      id: 'vessel_sailing_date',
      isRequired: true,
      isBackDateRequired: true,
      placeholder: 'Enter date here',
    },
    {
      label: 'ETA - Port of Destination',
      input_type: 'date',
      id: 'eta_date_port_destination',
      isRequired: false,
      isBackDateRequired: true,
      placeholder: 'Enter date here',
    },
  ],
};

module.exports = {
  childIndentTimelineValues,
  containerAirFormFields,
  containerFormFields,
};
